<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.orders.headers.bill_send") }}
    </h4>
    <div class="row">
      <div class="form-group">
        <n-checkbox
          v-for="(email, index) in this.item.emails"
          :key="`email-${index}`"
          @change="setEmail(email, $event)"
        >
          {{ email }}
        </n-checkbox>
      </div>
    </div>
    <div
      slot="footer"
      style="margin-top: 10px; padding-top: 20px; border-top: outset"
      class="text-center"
    >
      <n-button class="pull-left btn-secondary" @click.native="cancelSend()">{{
        $t("app.buttons.cancel")
      }}</n-button>
      <n-button
        class="pull-right btn-primary"
        @click.native="sendBill()"
        :disabled="isDisabled"
        >{{ $t("app.general.send") }}</n-button
      >
    </div>
  </modal>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      modals: {
        classic: false,
      },
      item: {
        id: 0,
        emails: [],
      },
      emails: [],
      disabled: true,
    };
  },
  computed: {
    isDisabled() {
      return this.disabled;
    },
  },
  mounted() {
    EventBus.$on("send-bill", async (item) => {
      this.item.id = item.id;
      this.item.emails = item.emails;
      this.modals.classic = true;
      console.log(this.item);
    });
  },
  methods: {
    cancelSend() {
      this.modals.classic = false;
    },
    setEmail(email, event) {
      // console.log(email, event)
      if (event) {
        this.emails.push(email);
      } else {
        this.emails.pop(email);
      }
      // console.log(this.emails)
      if (this.emails.length > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    async sendBill() {
      var payload = {
        id: this.item.id,
        claveIdioma: "",
        usuario: this.$store.state.user.idUsuario,
        correos: this.emails,
      };

      await this.$http
        .post(route("FacturacionCliente/sendFacturasCliente"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.send_success"));
            } else {
              this.notifyMessage("danger", response.body.message);
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});

        this.modals.classic = false;
    },
  },
};
</script>

<style scoped>
</style>